/**
 * Platform identifier sent with session / agent / team / chat API requests.
 * Defaults to 'spacebring_labs'; overridable via REACT_APP_PLATFORM_ID.
 */
export const PLATFORM_ID = process.env.REACT_APP_PLATFORM_ID || 'spacebring_labs';

/** Legacy platform id still used by a few unrelated endpoints. */
export const LEGACY_PLATFORM_ID = 'abode';

/** Domain id used to scope team and agent list/create requests. */
export const DOMAIN_ID = 'f6ea992b-a399-4fff-b76e-03804722878c';

/** Chat API — shares the same platform id as the core flows. */
export const CHAT_PLATFORM_ID = 'spacebring_labs';

/** Auth (login/signup) APIs — platform key sent in the request body. */
export const AUTH_PLATFORM = 'spacebring_labs';

export default PLATFORM_ID;
